// src/components/sections/ApplicationSection.jsx
import { useTranslation } from "react-i18next";

import agent from "../../assets/img/gopapelessagent.svg";
import portal from "../../assets/img/gopaperlessportal.svg";
import billing from "../../assets/img/trustedbilling.svg";

import contactbg from "../../assets/background/contactbg.png";
import PortalFeatureCard from "../common/PortalFeatureCard";

export default function EcosystemSection() {
  const { t, i18n } = useTranslation();
  // Giữ đúng locale hiện tại (/en hoặc /vi) khi mở link hệ sinh thái
  const lang = i18n.language?.toLowerCase().startsWith("vi") ? "vi" : "en";

  const openLocalizedUrl = (baseUrl) => {
    const normalizedBase = baseUrl.replace(/\/+$/, "");
    window.open(`${normalizedBase}/${lang}`, "_blank");
  };

  return (
    <section
      id="ecosystem"
      className="relative isolate text-white bg-cover bg-center bg-no-repeat px-4 py-36 tabletair:py-16 tabletmini:py-16 mobile:py-10 mobile:px-4 tabletpro:px-10 tabletair:px-10 tabletmini:px-10"
      style={{ backgroundImage: `url(${contactbg})` }}
    >
      <div className="max-w-[1400px] mx-auto flex flex-col mobile:gap-1 gap-[48px]">
        {/* Headline */}
        <div className="flex flex-col gap-[16px] mx-auto text-center">
          <p className="text-[20px] mobile:text-[14px] font-medium text-brandBlue-500 tracking-wide uppercase">
            {t("ecosystem.caption", { defaultValue: "HỆ SINH THÁI" })}
          </p>
          <h2 className="text-[56px] font-semibold mobile:text-[24px] tabletpro:text-[56px] tabletair:text-[36px] tabletmini:text-[32px] text-neutral-1 font-md max-w-[1400px] mx-auto">
            {t("ecosystem.headline", {
              defaultValue: "Hệ sinh thái Quantera",
            })}
          </h2>
        </div>

        {/* APPLICATION GRID - 3 CỘT */}
        <div className="grid grid-cols-1 tabletmini:grid-cols-2 desktop:grid-cols-3 gap-4 mt-16 mobile:mt-4 tabletpro:items-stretch tabletpro:justify-center mx-auto overflow-visible">
          {/* CARD 1 - GOPAPERLESS AGENT */}
          <PortalFeatureCard
            title="GoPaperless Agent"
            description={t("ecosystem.gopaperlessagent", { defaultValue: "" })}
            imageSrc={agent}
            onClick={() => openLocalizedUrl("https://agent.quantera.vn/")}
          />

          {/* CARD 2 - GOPAPERLESS PORTAL */}
          <PortalFeatureCard
            title="GoPaperless Portal"
            description={t("ecosystem.gopaperless", { defaultValue: "" })}
            imageSrc={portal}
            onClick={() => openLocalizedUrl("https://gopaperless.quantera.vn/")}
          />

          {/* CARD 3 - TRUSTED BILLING */}
          <PortalFeatureCard
            title="Trusted Billing"
            description={t("ecosystem.trustedbilling", { defaultValue: "" })}
            imageSrc={billing}
            onClick={() => openLocalizedUrl("https://trustedbilling.mobile-id.vn/")}
          />
        </div>
      </div>
    </section>
  );
}
